import type { CategoryColor, Slice } from "@/lib/dashboard";

/** Classes literais (o Tailwind só gera o que aparece escrito no código). */
const STROKE: Record<CategoryColor, string> = {
  "cat-1": "stroke-cat-1",
  "cat-2": "stroke-cat-2",
  "cat-3": "stroke-cat-3",
  "cat-4": "stroke-cat-4",
  "cat-5": "stroke-cat-5",
  "cat-other": "stroke-cat-other",
};
export const SWATCH: Record<CategoryColor, string> = {
  "cat-1": "bg-cat-1",
  "cat-2": "bg-cat-2",
  "cat-3": "bg-cat-3",
  "cat-4": "bg-cat-4",
  "cat-5": "bg-cat-5",
  "cat-other": "bg-cat-other",
};

const R = 42;
const C = 2 * Math.PI * R;
const GAP = 1.6; // separação entre fatias, na cor do fundo

/** Rosca em SVG próprio (sem biblioteca de gráficos). A legenda com valores fica com quem usa. */
export function Donut({
  slices,
  label,
  size = 132,
  children,
}: {
  slices: Slice[];
  label: string;
  size?: number;
  children?: React.ReactNode;
}) {
  const total = slices.reduce((s, x) => s + x.valueMinor, 0);
  const description = total
    ? `${label}: ${slices.map((s) => `${s.name} ${Math.round((s.valueMinor / total) * 100)}%`).join(", ")}`
    : label;
  let offset = 0;
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      <svg viewBox="0 0 100 100" width={size} height={size} role="img" aria-label={description}>
        <g transform="rotate(-90 50 50)" fill="none" strokeWidth="12">
          <circle cx="50" cy="50" r={R} className="stroke-surface-2" />
          {total > 0 &&
            slices.map((s) => {
              const len = (s.valueMinor / total) * C;
              const dash = Math.max(len - (slices.length > 1 ? GAP : 0), 0.5);
              const el = (
                <circle
                  key={s.key}
                  cx="50"
                  cy="50"
                  r={R}
                  className={STROKE[s.color]}
                  strokeDasharray={`${dash} ${C}`}
                  strokeDashoffset={-offset}
                />
              );
              offset += len;
              return el;
            })}
        </g>
      </svg>
      {children && (
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          {children}
        </div>
      )}
    </div>
  );
}
